import React from 'react';

import { Navbar, Nav, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import HelpButton from './Help';

import logosm from '../../byne-sm.png';
import logo from '../../byne.png';

function TopBar(props) {

  return (
    <Navbar bg="dark" variant="dark" fixed="top" expand="true">
      <Navbar.Brand href="#home" >
        <img
          src={logosm}
          height="30"
          className="align-top d-block d-sm-none"
          alt="BYNE"
        />
        <img
          src={logo}
          height="30"
          className="align-top d-none d-sm-block"
          alt="BYNE"
        />
      </Navbar.Brand>
      <Navbar className="justify-content-end">
        <Navbar.Text>
            {props.name}
        </Navbar.Text>
        <Nav className="justify-content-end">
          <Nav.Link>
            <Button variant={props.mediaState === "connected" ? "outline-success" : "outline-secondary"}
                    onClick={props.showAudioConnection}>
              <FontAwesomeIcon icon="phone-alt" />
            </Button>
          </Nav.Link>
          <Nav.Link>
            <HelpButton />
          </Nav.Link>
          <Nav.Link href="/logout">
            <Button variant="outline-secondary">
              <FontAwesomeIcon icon="sign-out-alt" />
            </Button>
          </Nav.Link>
        </Nav>
      </Navbar>
    </Navbar>
  )
}

export default TopBar;
